import instance from "@/services/api";

export const projectPatternAPI = {
  async getProjectPattern(projectGuid) {
    return await instance()
      .get("/project/project_pattern/read/", { params: { project_guid: projectGuid } })
      .then((res) => res?.data);
  },
  async getProjectByGuid(projectGuid, projectId = null) {
    return await instance()
      .get("/project/project_by_guid/read/", { 
        params: { 
          project_guid: projectGuid,
          project_id: projectId 
        } 
      })
      .then((res) => res?.data);
  },
  async updateEntranceLink(project_entrance_id, usp_block_guid) {
    return await instance()
      .put("/project/entrance/usp_link/update/", { 
        project_entrance_id, 
        usp_block_guid 
      })
      .then((res) => res?.data);
  },
  async updateFloorLink(floor_map_id, usp_level_guid) {
    return await instance()
      .put("/project/floor/usp_link/update/", { 
        floor_map_id, 
        usp_level_guid 
      })
      .then((res) => res?.data);
  },
  async autoLinkEntranceSiblingsByName(project_entrance_id, target_usp_guid) {
    return await instance()
      .post("/project/entrance/usp_link/auto_siblings/", { 
        project_entrance_id, 
        target_usp_guid 
      })
      .then((res) => res?.data);
  },
  async autoLinkFloorSiblingsByName(floor_map_id, target_usp_guid) {
    return await instance()
      .post("/project/floor/usp_link/auto_siblings/", { 
        floor_map_id, 
        target_usp_guid 
      })
      .then((res) => res?.data);
  },
  async autoMapSbsByGuid(project_guid) {
    return await instance()
      .post("/project/auto_map_sbs/", { 
        project_guid 
      })
      .then((res) => res?.data);
  },
  async getProjectGroups() {
    return await instance()
      .get("/project/project_group/read/")
      .then((res) => res?.data);
  },
  async ingestProjectGroups() {
    return await instance()
      .post("/project/project_group/ingest/")
      .then((res) => res?.data);
  },
  async checkSendReadiness(projectGuid, projectId = null) {
    return await instance()
      .get("/project/project_pattern/check_send/", {
        params: {
          project_guid: projectGuid,
          project_id: projectId
        }
      })
      .then((res) => res?.data);
  },
  async getGprPeriods(projectGuid, uspLevelGuids) {
    return await instance()
      .post("/project/project_pattern/gpr_periods/read/", {
        project_guid: projectGuid,
        usp_level_guids: uspLevelGuids,
      })
      .then((res) => res?.data);
  },
  async ingestProjectPattern(project_guid, url) {
    return await instance()
      .post("/project/project_pattern/ingest/", { 
        project_guid,
        url 
      })
      .then((res) => res?.data);
  },
  async getUspFloorMapSend(floor_map_id = null, project_id = null, project_entrance_id = null) {
    return await instance()
      .get("/project/usp_floor_map_send/read/", { 
        params: { 
          floor_map_id,
          project_id,
          project_entrance_id
        } 
      })
      .then((res) => res?.data);
  },
  async getProjectUspJson(projectId) {
    return await instance()
      .get("/project/project_by_guid/usp_json/", { params: { project_id: projectId } })
      .then((res) => res?.data);
  },
  async getUspFactForOperfact(floor_map_id = null, project_entrance_id = null) {
    return await instance()
      .get("/project/usp_fact/operfact/", { params: { floor_map_id, project_entrance_id } })
      .then((res) => res?.data);
  },
  async getUspFactMaterialByFact(usp_fact_id) {
    return await instance()
      .get("/project/usp_fact_material/read/", { params: { usp_fact_id } })
      .then((res) => res?.data);
  },
  async getSectionMap() {
    return await instance()
      .get("/project/section_map/read/")
      .then((res) => res?.data);
  },
  async modifySectionMap(body) {
    return await instance()
      .post("/project/section_map/modify/", body)
      .then((res) => res?.data);
  },
  async deleteSectionMap(id) {
    return await instance()
      .delete("/project/section_map/delete/", { params: { project_type_section_map_id: id } })
      .then((res) => res?.data);
  },
  async getSectionMapProjectTypes() {
    return await instance()
      .get("/project/section_map/project_types/")
      .then((res) => res?.data);
  },
  async savePpmPeriod(body) {
    return await instance()
      .post("/project/project_pattern/period/save/", body)
      .then((res) => res?.data);
  },
  async materialSearch(search = null) {
    return await instance()
      .post("/project/project_pattern/material/search/", { search })
      .then((res) => res?.data);
  },

  async getWorkDetail(floorMapId, workSetId, workSetCheckGroupId) {
    return await instance()
      .post("/project/project_pattern/work_detail/read/", {
        floor_map_id:            floorMapId,
        work_set_id:             workSetId,
        work_set_check_group_id: workSetCheckGroupId,
      })
      .then((res) => res?.data);
  },

  async getWorkGuidByProject(projectGuid, blockGuid, etazhGuid, projectId) {
    return await instance()
      .post("/project/project_pattern/work_guid/get/", {
        project_guid: projectGuid,
        block_guid:   blockGuid,
        etazh_guid:   etazhGuid,
        project_id:   projectId,
      })
      .then((res) => res?.data);
  },
  async checkWorkGuidsBatch(projectGuid) {
    return await instance()
      .post("/project/project_pattern/work_guid/check_batch/", {
        project_guid: projectGuid,
      })
      .then((res) => res?.data);
  },
  async getWorkSetsForFloor(floorMapId) {
    return await instance()
      .get(`/project/floor_map/${floorMapId}/work_set/read/`)
      .then((res) => res?.data);
  },
  async getWorkSetsForMatrix(floorMapId) {
    return await instance()
      .get(`/project/floor_map/${floorMapId}/work_set/matrix/read/`)
      .then((res) => res?.data);
  },
  async uspFactSave(body) {
    return await instance()
      .post("/project/project_pattern/usp_fact/save/", body, { _skipErrorToast: true })
      .then((res) => res?.data);
  },

  async uspFactRead(params) {
    return await instance()
      .post("/project/project_pattern/usp_fact/read/", params)
      .then((res) => res?.data);
  },

  async uspFactSummaryRead(params) {
    return await instance()
      .post("/project/project_pattern/usp_fact/summary/", params)
      .then((res) => res?.data);
  },

  async uspFactHistoryRead(params) {
    return await instance()
      .post("/project/project_pattern/usp_fact/history/", params)
      .then((res) => res?.data);
  },

  async uspFactDelete(body) {
    return await instance()
      .post("/project/project_pattern/usp_fact/delete/", body)
      .then((res) => res?.data);
  },

  async uspSbsDataRefresh(projectGuid) {
    return await instance()
      .post("/project/project_pattern/usp_sbs_data/refresh/", { project_guid: projectGuid })
      .then((res) => res?.data);
  },

  async uspReportRead(projectGuid) {
    return await instance()
      .get("/project/project_pattern/usp_report/read/", { params: { project_guid: projectGuid } })
      .then((res) => res?.data);
  },

  async uspReportFactsRead(projectGuid, workGuid) {
    return await instance()
      .get("/project/project_pattern/usp_report/facts/read/", {
        params: { project_guid: projectGuid, work_guid: workGuid },
      })
      .then((res) => res?.data);
  },

  async uspReportWorkDetailRead(projectGuid, floorMapId, workSetId, workSetCheckGroupId) {
    return await instance()
      .get("/project/project_pattern/usp_report/work_detail/read/", {
        params: {
          project_guid: projectGuid,
          floor_map_id: floorMapId,
          work_set_id: workSetId,
          work_set_check_group_id: workSetCheckGroupId,
        },
      })
      .then((res) => res?.data);
  },

  async uspReportUspDetailRead(projectGuid, uspWorkGuid) {
    return await instance()
      .get("/project/project_pattern/usp_report/usp_detail/read/", {
        params: { project_guid: projectGuid, usp_work_guid: uspWorkGuid },
      })
      .then((res) => res?.data);
  },

  async projectPatternReadFiltered(projectGuid, projectTypeName, contractorId) {
    return await instance()
      .post("/project/project_pattern/read_filtered/", {
        project_guid:       projectGuid,
        project_type_name:  projectTypeName || null,
        contractor_id:      contractorId    || null,
      })
      .then((res) => res?.data);
  },

  async getProjectTypes(projectGuid) {
    return await instance()
      .post("/project/project_pattern/project_types/read/", { project_guid: projectGuid })
      .then((res) => res?.data);
  },

  async getContractors(projectGuid) {
    return await instance()
      .post("/project/project_pattern/contractors/read/", { project_guid: projectGuid })
      .then((res) => res?.data);
  },

  async getContractorsSMR(projectGuid, projectTypeId = null) {
    return await instance()
      .post("/project/project_pattern/contractors_smr/read/", {
        project_guid:    projectGuid,
        project_type_id: projectTypeId,
      })
      .then((res) => res?.data);
  },

  async uspWorkComplete(body) {
    return await instance()
      .post("/project/project_pattern/usp_work/complete/", body)
      .then((res) => res?.data);
  },

  async uspFactFillWorkGuid(body) {
    return await instance()
      .post("/project/project_pattern/usp_fact/fill_work_guid/", body)
      .then((res) => res?.data);
  },

  async uspFactSend(body) {
    return await instance()
      .post("/project/project_pattern/usp_fact/send/", body)
      .then((res) => res?.data);
  },

  async uspFactCorrectionSave(body) {
    return await instance()
      .post("/project/project_pattern/usp_fact/correction_save/", body)
      .then((res) => res?.data);
  },

  async uspFactCorrectionRead(body) {
    return await instance()
      .post("/project/project_pattern/usp_fact/correction_read/", body)
      .then((res) => res?.data);
  },

  async uspFactBuildJsonSelected(body) {
    return await instance()
      .post("/project/project_pattern/usp_fact/build_json_selected/", body)
      .then((res) => res?.data);
  },

  async uspFactBuildCorrectionJson(body) {
    return await instance()
      .post("/project/project_pattern/usp_fact/build_correction_json/", body)
      .then((res) => res?.data);
  },

  async uspFactBuildStornoJson(body) {
    return await instance()
      .post("/project/project_pattern/usp_fact/build_storno_json/", body)
      .then((res) => res?.data);
  },

  async uspFactBuildStornoJsonPartial(body) {
    return await instance()
      .post("/project/project_pattern/usp_fact/build_storno_json_partial/", body)
      .then((res) => res?.data);
  },

  async uspFactSendAction(body) {
    return await instance()
      .post("/project/project_pattern/usp_fact/send_action/", body)
      .then((res) => res?.data);
  },

  async uspFactSendActionPartial(body) {
    return await instance()
      .post("/project/project_pattern/usp_fact/send_action_partial/", body)
      .then((res) => res?.data);
  },

  async uspFactSendSelected(body) {
    return await instance()
      .post("/project/project_pattern/usp_fact/send_selected/", body)
      .then((res) => res?.data);
  },

  async getProjectTypesByContractor(projectGuid, contractorId) {
    return await instance()
      .post("/project/project_pattern/project_types_by_contractor/read/", {
        project_guid:  projectGuid,
        contractor_id: contractorId,
      })
      .then((res) => res?.data);
  },

  async getContractorsByType(projectGuid, projectTypeId) {
    return await instance()
      .post("/project/project_pattern/contractors_by_type/read/", {
        project_guid:    projectGuid,
        project_type_id: projectTypeId,
      })
      .then((res) => res?.data);
  },

  async uspDiscrepancyRead(params) {
    return await instance()
      .post("/project/project_pattern/usp_fact/discrepancy/", params)
      .then((res) => res?.data);
  },

  async uspDiscrepancyDetailRead(params) {
    return await instance()
      .post("/project/project_pattern/usp_fact/discrepancy/detail/", params)
      .then((res) => res?.data);
  },

  async uspStornoListRead(params) {
    return await instance()
      .post("/project/project_pattern/usp_fact/storno/list/", params)
      .then((res) => res?.data);
  },

  async uspFactAlignToSmeta(params) {
    return await instance()
      .post("/project/project_pattern/usp_fact/align_to_smeta/", params)
      .then((res) => res?.data);
  },

  async getSmetaSummary(projectGuid, projectId = null) {
    return await instance()
      .get("/project/project_pattern/smeta_summary/", {
        params: {
          project_guid: projectGuid,
          project_id: projectId,
        },
      })
      .then((res) => res?.data);
  },
  async smetaChangeLogUnsignedRead(params) {
    return await instance()
      .post("/project/project_pattern/smeta_change_log/unsigned/", params)
      .then((res) => res?.data);
  },

  async cronHistoryRead(params) {
    return await instance()
      .post("/project/project_pattern/cron/history/", params)
      .then((res) => res?.data);
  },

  async cronLogJsonRead(params) {
    return await instance()
      .post("/project/project_pattern/cron/log_json/", params)
      .then((res) => res?.data);
  },

  async cronStatusRead(params) {
    return await instance()
      .post("/project/project_pattern/cron/status/", params)
      .then((res) => res?.data);
  },

  async cronUpdateSmeta() {
    return await instance()
      .post("/project/project_pattern/cron/update_smeta/", {})
      .then((res) => res?.data);
  },

  async cronCreateContracts() {
    return await instance()
      .post("/project/project_pattern/cron/create_contracts/", {})
      .then((res) => res?.data);
  },

  async uspEstimateSendSelected(body) {
    return await instance()
      .post("/project/project_pattern/usp_estimate/send_selected/", body)
      .then((res) => res?.data);
  },

  async uspEstimateBuildJson(body) {
    return await instance()
      .post("/project/project_pattern/usp_estimate/build_json/", body)
      .then((res) => res?.data);
  },
};

